// extracted by css-extract-rspack-plugin
export default {"video":"ModelsVideo-module__video___Zce8j","thumbnail":"ModelsVideo-module__thumbnail___C5k1J"};